const TIPO_FAIXA_IS = 'FAIXA_IS';
const TIPO_CATEGORIA_KM = 'CATEGORIA_KM';
const TIPO_ATRIBUTO_CATEGORIA = 'ATRIBUTO_CATEGORIA';

const VALOR_MOEDA = 'MOEDA';
const VALOR_PERCENTUAL = 'PERCENTUAL';
const VALOR_TAXA = 'TAXA';

const ATRIBUTOS_VIDROS = {
  BASICO: { titulo: 'Básico', formato: VALOR_MOEDA },
  COMPLETO: { titulo: 'Completo', formato: VALOR_MOEDA },
  FRANQUIA: { titulo: 'Franquia', formato: VALOR_PERCENTUAL }
};
const TIPO_PERIODO_CATEGORIA = 'PERIODO_CATEGORIA';
const TEXTO_NAO_APLICAVEL = 'NA';

const CASAS_IS = 7;
const CASAS_KM = 2;

const FATOR_IS_MAXIMO = 1;
const VALOR_KM_MAXIMO = 999999.99;

function ehNulo(valor) {
  return valor === null || valor === undefined || valor === '';
}

function formatarNumeroBR(valor, casas) {
  const numero = Number(valor);
  if (isNaN(numero)) return '';
  const negativo = numero < 0;
  const texto = Math.abs(numero).toFixed(casas);
  const partes = texto.split('.');
  const inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimal = partes.length > 1 ? `,${partes[1]}` : '';
  return `${negativo ? '-' : ''}${inteiro}${decimal}`;
}

const PREFIXO_MOEDA = 'R$ ';
const DIGITOS_INTEIROS_KM = 6;
const CASAS_PERCENTUAL = 2;
const DIGITOS_INTEIROS_PERCENTUAL = 3;
const SUFIXO_PERCENTUAL = '%';
const PERCENTUAL_MAXIMO = 100;

function ehSignificativo(caractere) {
  return /[\d,]/.test(caractere);
}

function inteiroEDecimalMoeda(bruto) {
  const semPrefixo = String(ehNulo(bruto) ? '' : bruto).replace(/^R?\$?\s*/, '');
  const limpo = semPrefixo.replace(/[^\d,]/g, '');
  const virgula = limpo.indexOf(',');
  if (virgula === -1) return { inteiro: limpo, decimal: null };
  return {
    inteiro: limpo.slice(0, virgula),
    decimal: limpo.slice(virgula + 1).replace(/,/g, '')
  };
}

function casasDecimaisDe(valor) {
  const texto = String(valor);
  if (texto.indexOf('e') !== -1 || texto.indexOf('E') !== -1) return 0;
  const ponto = texto.indexOf('.');
  if (ponto === -1) return 0;
  return texto.length - ponto - 1;
}

function percentualInteiro(fracao) {
  return Math.round(Number((Number(fracao) * 100).toPrecision(12)));
}

export default {
  TIPO_FAIXA_IS,
  TIPO_CATEGORIA_KM,
  TIPO_ATRIBUTO_CATEGORIA,
  VALOR_MOEDA,
  VALOR_PERCENTUAL,
  VALOR_TAXA,
  SUFIXO_PERCENTUAL,
  TIPO_PERIODO_CATEGORIA,
  TEXTO_NAO_APLICAVEL,
  CASAS_IS,
  CASAS_KM,
  FATOR_IS_MAXIMO,
  VALOR_KM_MAXIMO,

  ehCoberturaKm(cobertura) {
    return !!cobertura && cobertura.tipo === TIPO_CATEGORIA_KM;
  },

  ehCoberturaPeriodo(cobertura) {
    return !!cobertura && cobertura.tipo === TIPO_PERIODO_CATEGORIA;
  },

  ehCoberturaAtributo(cobertura) {
    return !!cobertura && cobertura.tipo === TIPO_ATRIBUTO_CATEGORIA;
  },

  ehCoberturaMoeda(cobertura) {
    return this.ehCoberturaKm(cobertura) || this.ehCoberturaPeriodo(cobertura);
  },

  tipoValor(cobertura, faixa) {
    if (this.ehCoberturaMoeda(cobertura)) return VALOR_MOEDA;
    if (this.ehCoberturaAtributo(cobertura)) {
      return faixa && faixa.formato === VALOR_PERCENTUAL ? VALOR_PERCENTUAL : VALOR_MOEDA;
    }
    return VALOR_TAXA;
  },

  casasDecimais(cobertura, faixa) {
    const tipo = this.tipoValor(cobertura, faixa);
    if (tipo === VALOR_MOEDA) return CASAS_KM;
    if (tipo === VALOR_PERCENTUAL) return CASAS_PERCENTUAL;
    return CASAS_IS;
  },

  tituloAtributo(atributo) {
    return ATRIBUTOS_VIDROS[atributo] ? ATRIBUTOS_VIDROS[atributo].titulo : atributo || '';
  },

  celulaNaoAplicavel(cobertura, celula) {
    const temNaoAplicavel = this.ehCoberturaPeriodo(cobertura) || this.ehCoberturaAtributo(cobertura);
    return temNaoAplicavel && !!celula && ehNulo(celula.fator);
  },

  rotuloNaoAplicavel(cobertura, faixa) {
    return this.tipoValor(cobertura, faixa) === VALOR_PERCENTUAL
      ? 'Não aplicável'
      : TEXTO_NAO_APLICAVEL;
  },

  elegivelAjusteMassa(cobertura) {
    return !!cobertura && !this.ehCoberturaPeriodo(cobertura) && !this.ehCoberturaAtributo(cobertura);
  },

  coberturasAjusteMassa(coberturas) {
    return (coberturas || []).filter(c => this.elegivelAjusteMassa(c));
  },

  tabelaInicialAjusteMassa(coberturas, tabelaAtiva) {
    const elegiveis = this.coberturasAjusteMassa(coberturas);
    if (elegiveis.some(c => c.tabela === tabelaAtiva)) return tabelaAtiva;
    return elegiveis.length > 0 ? elegiveis[0].tabela : '';
  },

  formatarIS(valor) {
    if (ehNulo(valor)) return '';
    return formatarNumeroBR(valor, 2);
  },

  formatarTaxa(valor) {
    if (ehNulo(valor)) return '';
    return formatarNumeroBR(valor, CASAS_IS);
  },

  formatarMoeda(valor) {
    if (ehNulo(valor)) return '';
    const numero = Number(valor);
    if (isNaN(numero)) return '';
    return `R$ ${formatarNumeroBR(numero, CASAS_KM)}`;
  },

  formatarPercentual(valor) {
    if (ehNulo(valor)) return '';
    const numero = Number(valor);
    if (isNaN(numero)) return '';
    return `${percentualInteiro(numero)}${SUFIXO_PERCENTUAL}`;
  },

  formatarValorCelula(cobertura, valor, faixa) {
    if (ehNulo(valor)) return '';
    const tipo = this.tipoValor(cobertura, faixa);
    if (tipo === VALOR_MOEDA) return this.formatarMoeda(valor);
    if (tipo === VALOR_PERCENTUAL) return this.formatarPercentual(valor);
    return this.formatarTaxa(valor);
  },

  parseTaxa(bruto) {
    const limpo = String(ehNulo(bruto) ? '' : bruto)
      .replace(',', '.')
      .replace(/[^\d.]/g, '');
    if (limpo === '') return null;
    const valor = parseFloat(limpo);
    return isNaN(valor) ? null : valor;
  },

  parseMoeda(bruto) {
    let limpo = String(ehNulo(bruto) ? '' : bruto).replace(/[^\d,.-]/g, '');
    if (limpo.indexOf(',') !== -1) {
      limpo = limpo.replace(/\./g, '').replace(',', '.');
    }
    if (limpo === '' || limpo === '-') return null;
    const valor = parseFloat(limpo);
    return isNaN(valor) ? null : valor;
  },

  mascararTaxa(bruto) {
    const limpo = String(ehNulo(bruto) ? '' : bruto).replace(/[^\d,]/g, '');
    const primeiraVirgula = limpo.indexOf(',');
    if (primeiraVirgula === -1) return limpo;
    const inteiro = limpo.slice(0, primeiraVirgula);
    const decimal = limpo.slice(primeiraVirgula + 1).replace(/,/g, '');
    return `${inteiro},${decimal.slice(0, CASAS_IS)}`;
  },

  parsePercentualInteiro(bruto) {
    const mascarado = this.mascararPercentual(bruto);
    if (mascarado === '') return null;
    return parseInt(mascarado, 10) / 100;
  },

  parseValorCelula(cobertura, bruto, faixa) {
    const tipo = this.tipoValor(cobertura, faixa);
    if (tipo === VALOR_MOEDA) return this.parseMoeda(bruto);
    if (tipo === VALOR_PERCENTUAL) return this.parsePercentualInteiro(bruto);
    return this.parseTaxa(bruto);
  },

  mascararPercentual(bruto) {
    const digitos = String(ehNulo(bruto) ? '' : bruto).replace(/\D/g, '');
    if (digitos === '') return '';
    const semZeros = digitos.replace(/^0+(?=\d)/, '');
    const numero = semZeros.length > DIGITOS_INTEIROS_PERCENTUAL
      ? PERCENTUAL_MAXIMO
      : Math.min(parseInt(semZeros, 10), PERCENTUAL_MAXIMO);
    return `${numero}${SUFIXO_PERCENTUAL}`;
  },

  PREFIXO_MOEDA,

  mascararMoeda(bruto) {
    const partes = inteiroEDecimalMoeda(bruto);
    let inteiro = partes.inteiro.replace(/^0+(?=\d)/, '');
    if (partes.decimal !== null && inteiro === '') inteiro = '0';
    inteiro = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const decimal = partes.decimal === null ? '' : `,${partes.decimal.slice(0, CASAS_KM)}`;
    return `${PREFIXO_MOEDA}${inteiro}${decimal}`;
  },

  excedeLimiteMoeda(bruto) {
    const inteiro = inteiroEDecimalMoeda(bruto).inteiro.replace(/^0+(?=\d)/, '');
    return inteiro.length > DIGITOS_INTEIROS_KM;
  },

  contarSignificativos(texto, ate) {
    return String(texto).slice(0, ate).split('').filter(ehSignificativo).length;
  },

  posicaoAposSignificativos(texto, quantidade) {
    const valor = String(texto);
    let restantes = quantidade;
    let posicao = PREFIXO_MOEDA.length;
    for (let i = PREFIXO_MOEDA.length; i < valor.length && restantes > 0; i++) {
      if (ehSignificativo(valor[i])) restantes--;
      posicao = i + 1;
    }
    return posicao;
  },

  sanitizarPercentual(bruto) {
    const texto = String(ehNulo(bruto) ? '' : bruto).trim();
    const negativo = texto.charAt(0) === '-';
    const limpo = texto.replace(/\./g, ',').replace(/[^\d,]/g, '');
    const virgula = limpo.indexOf(',');
    let inteiro = virgula === -1 ? limpo : limpo.slice(0, virgula);
    inteiro = inteiro.slice(0, DIGITOS_INTEIROS_PERCENTUAL);
    const decimal = virgula === -1
      ? ''
      : `,${limpo.slice(virgula + 1).replace(/,/g, '').slice(0, CASAS_PERCENTUAL)}`;
    return `${negativo ? '-' : ''}${inteiro}${decimal}`;
  },

  parsePercentual(bruto) {
    const texto = this.sanitizarPercentual(bruto).replace(',', '.');
    if (!/\d/.test(texto)) return null;
    const valor = parseFloat(texto);
    return isNaN(valor) ? null : valor;
  },

  rotulosAjusteMassa(cobertura) {
    if (this.ehCoberturaKm(cobertura)) {
      return {
        cobertura: 'Cobertura Afetada',
        escopo: 'Escopo do Ajuste',
        escopoTudo: 'Aplicar em Toda a cobertura Selecionada',
        escopoColuna: 'Aplicar apenas na Categoria Tarifária',
        escopoLinha: 'Aplicar apenas KM de Assistência',
        campoColuna: 'Categoria Tarifária',
        campoLinha: 'KM de Assistência',
        percentual: 'Percentual de Ajuste (Use Negativo para Redução)'
      };
    }
    return {
      cobertura: 'Cobertura afetada',
      escopo: 'Escopo do ajuste',
      escopoTudo: 'Toda(s) a(s) cobertura(s) selecionada',
      escopoColuna: 'Aplicar somente categoria tarifária',
      escopoLinha: 'Aplicar apenas na Faixa de IS',
      campoColuna: 'Categoria tarifária',
      campoLinha: 'Faixa de IS',
      percentual: 'Percentual de ajuste (use negativo para reduzir)'
    };
  },

  arredondar(cobertura, valor, faixa) {
    const numero = Number(valor);
    if (isNaN(numero)) return null;
    if (this.tipoValor(cobertura, faixa) === VALOR_PERCENTUAL) {
      return percentualInteiro(numero) / 100;
    }
    const casas = this.casasDecimais(cobertura, faixa);
    const [mantissa, expoente] = numero.toExponential(14).split('e');
    const deslocado = Math.round(Number(`${mantissa}e${Number(expoente) + casas}`));
    return Number(`${deslocado}e-${casas}`);
  },

  idColunaDaCelula(cobertura, celula) {
    if (!celula) return null;
    if (this.ehCoberturaAtributo(cobertura)) {
      return celula.idColuna === undefined ? null : celula.idColuna;
    }
    return celula.idCatVeiculo === undefined ? null : celula.idCatVeiculo;
  },

  idColunaDaAlteracao(alteracao) {
    if (!alteracao) return null;
    if (!ehNulo(alteracao.idColuna)) return alteracao.idColuna;
    return alteracao.idCatVeiculo === undefined ? null : alteracao.idCatVeiculo;
  },

  colunasDa(cobertura, categorias) {
    if (this.ehCoberturaAtributo(cobertura)) return cobertura.colunas || [];
    return categorias || [];
  },

  cabecalhoLinha(cobertura) {
    if (this.ehCoberturaKm(cobertura)) return 'KM de Assistência';
    if (this.ehCoberturaPeriodo(cobertura)) return 'Período';
    if (this.ehCoberturaAtributo(cobertura)) return 'Atributo';
    return null;
  },

  tituloLinha(cobertura, faixa) {
    if (!faixa) return '';
    if (this.ehCoberturaMoeda(cobertura) || this.ehCoberturaAtributo(cobertura)) {
      return faixa.titulo || '';
    }
    return `${this.formatarIS(faixa.isMin)} — ${this.formatarIS(faixa.isMax)}`;
  },

  rotuloRodape(cobertura, quantidade) {
    if (this.ehCoberturaPeriodo(cobertura)) return `${quantidade} período(s)`;
    if (this.ehCoberturaAtributo(cobertura)) return `${quantidade} atributo(s)`;
    return this.ehCoberturaKm(cobertura)
      ? `${quantidade} KM(s) de assistência`
      : `${quantidade} faixa(s) de IS`;
  },

  chaveAlteracao(tabela, faixaIdx, idColuna) {
    return `${tabela}|${faixaIdx}|${idColuna}`;
  },

  montarAlteracao(cobertura, faixa, celula, valor, origem) {
    if (this.ehCoberturaAtributo(cobertura)) {
      return {
        tabela: cobertura.tabela,
        isMin: null,
        isMax: null,
        idCatVeiculo: celula.idCatVeiculo,
        idKmAssistencia: null,
        idOrigemVeiculo: ehNulo(celula.idOrigemVeiculo) ? null : celula.idOrigemVeiculo,
        atributo: faixa ? faixa.atributo : null,
        idColuna: celula.idColuna,
        atual: valor,
        origem: origem
      };
    }
    const km = this.ehCoberturaKm(cobertura);
    const periodo = this.ehCoberturaPeriodo(cobertura);
    const moeda = km || periodo;
    return {
      tabela: cobertura ? cobertura.tabela : null,
      isMin: moeda ? null : faixa.isMin,
      isMax: moeda ? null : faixa.isMax,
      idCatVeiculo: celula.idCatVeiculo,
      idKmAssistencia: km ? celula.idKmAssistencia : null,
      diasCarroReserva: periodo ? celula.diasCarroReserva : null,
      atual: valor,
      origem: origem
    };
  },

  valorAjustado(cobertura, valor, percentual) {
    if (ehNulo(valor) || percentual === null || percentual === undefined) return null;
    const fatorPercentual = Number((100 + Number(percentual)).toFixed(10));
    return this.arredondar(cobertura, (Number(valor) * fatorPercentual) / 100);
  },

  mudaComAjuste(cobertura, valor, percentual) {
    const ajustado = this.valorAjustado(cobertura, valor, percentual);
    return ajustado !== null && ajustado !== this.arredondar(cobertura, valor);
  },

  contarTaxasAfetadas(cobertura, valores, percentual) {
    return (valores || []).filter(v => this.mudaComAjuste(cobertura, v, percentual)).length;
  },

  valorValido(cobertura, valor, faixa) {
    if (ehNulo(valor)) return false;
    const numero = Number(valor);
    if (isNaN(numero)) return false;
    const tipo = this.tipoValor(cobertura, faixa);
    if (tipo === VALOR_PERCENTUAL) {
      return numero >= 0 && numero <= 1 && Math.abs(numero * 100 - percentualInteiro(numero)) < 1e-9;
    }
    if (tipo === VALOR_MOEDA) {
      return numero > 0 && numero <= VALOR_KM_MAXIMO && casasDecimaisDe(numero) <= CASAS_KM;
    }
    return numero > 0 && numero <= FATOR_IS_MAXIMO && casasDecimaisDe(numero) <= CASAS_IS;
  },

  limiteDescrito(cobertura, faixa) {
    const tipo = this.tipoValor(cobertura, faixa);
    if (tipo === VALOR_PERCENTUAL) return 'entre 0% e 100%, sem casas decimais';
    return tipo === VALOR_MOEDA
      ? `maior que zero e menor ou igual a ${this.formatarMoeda(VALOR_KM_MAXIMO)}`
      : `maior que zero e menor ou igual a ${FATOR_IS_MAXIMO}`;
  },

  tituloDias(dias) {
    return `${String(dias).padStart(2, '0')} dias`;
  },

  descreverFaixaAlteracao(alteracao) {
    if (!alteracao) return '';
    if (alteracao.atributo) return this.tituloAtributo(alteracao.atributo);
    if (!ehNulo(alteracao.diasCarroReserva)) return this.tituloDias(alteracao.diasCarroReserva);
    if (!ehNulo(alteracao.idKmAssistencia)) return `${alteracao.idKmAssistencia} Km`;
    return `${this.formatarIS(alteracao.isMin)} – ${this.formatarIS(alteracao.isMax)}`;
  },

  formatarValorAlteracao(alteracao, valor) {
    if (ehNulo(valor)) return '—';
    const atributo = alteracao ? ATRIBUTOS_VIDROS[alteracao.atributo] : null;
    if (atributo) {
      return atributo.formato === VALOR_PERCENTUAL
        ? this.formatarPercentual(valor)
        : this.formatarMoeda(valor);
    }
    const moeda = !!alteracao
      && (!ehNulo(alteracao.diasCarroReserva) || !ehNulo(alteracao.idKmAssistencia));
    return moeda ? this.formatarMoeda(valor) : this.formatarTaxa(valor);
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/gestao-taxas/gestao-taxas-helper.js